module.exports = __webpack_public_path__ + "img/back-icon-white.4d5459e3.svg";